<template>
  <component
    :is="tag"
    v-show="isOpen"
    class="sidebar"
    :width="{ base: '100%' }"
    :display="{ lg: 'flex' }"
    flex-direction="column"
    flex="0"
    :float="{ lg: 'left' }"
    bottom="0"
    left="0"
    :z-index="{ lg: '0' }"
    v-chakra="
      (theme) => ({
        backgroundColor: theme.colors.brand.gray,
        '.sidebar__anim--slide': {
          '&-enter-active': {
            transitionDuration: '0.08s',
            transitionTimingFunction: 'linear',
          },
          '&-leave-active': {
            transitionDuration: '0.08s',
            transitionTimingFunction: 'linear',
          },
          '&-enter-to, &-leave': {
            overflow: 'hidden',
            maxHeight: { base: '500px', lg: 'none' },
            maxWidth: { lg: '280px' },
            height: { lg: 'calc(100vh - 52px)' },
            opacity: { lg: 1 },
          },
          '&-enter, &-leave-to': {
            overflow: 'hidden',
            maxHeight: { base: 0, lg: 'none' },
            maxWidth: { lg: 0 },
          },
        },
        '@media print': {
          display: 'none !important',
        },
      })
    "
  >
    <!--
    NOTE: The v-show of component (above) hides the close animation of the sidebar. The v-show is
    needed because the component&transition consumes space in mobile view even when the nav is
    hidden, when using iframe inside a row with height:100%. Could not find another way to fix that...
    -->
    <transition name="sidebar__anim--slide">
      <nav
        v-show="isOpen"
        :class="{ 'sidebar__nav--open': isOpen }"
        :bg="{ base: 'brand.gray', lg: 'transparent' }"
        :display="{ base: 'block', lg: 'flex' }"
        flex-direction="column"
        :position="{ base: 'fixed', lg: 'sticky' }"
        zIndex="docked"
        :minHeight="{ base: '0', lg: 'calc(100vh - 88px)' }"
        :width="{ base: '100%', lg: '280px' }"
        :height="{ base: 'calc(100vh - 52px)', sm: 'calc(100vh - 68px)', lg: 'auto' }"
        :overflow-y="{ base: 'auto', lg: 'hidden' }"
        :mt="{ lg: '68px' }"
        v-chakra="{
          // object syntax doesn't work with top prop here, forced to use array syntax
          top: ['52px', '68px', '68px', '68px', '88px'],
        }"
        data-cy="sidebar-nav"
      >
        <ul
          class="nav"
          v-chakra="{
            marginTop: { base: '30px', lg: 0 },
            paddingTop: { base: 0, lg: '36px' },
            paddingBottom: { base: 0, lg: '36px' },
            overflow: { base: 'hidden', lg: 'visible' },
            position: { lg: 'relative' },
            height: { lg: 'calc(100vh - 68px)' },
            overflowY: { lg: 'auto' },
            '&::-webkit-scrollbar': {
              display: { lg: 'none' },
            },
          }"
        >
          <nav-item
            v-for="item in navItems"
            :key="item.id"
            :model="item"
            :data-cy="`sidebar-nav-item-${item.id}`"
            @navigate="onNavigate"
          ></nav-item>
        </ul>
      </nav>
    </transition>
  </component>
</template>
<script>
/**
 * Used as main page navigation in templates.
 */

import NavItem from "../elements/NavItem.vue";

export default {
  name: "SideBar",
  components: {
    "nav-item": NavItem,
  },
  status: "prototype",
  release: "0.0.1",
  props: {
    tag: {
      type: String,
      default: "aside",
    },
    navItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    openerText: "Open",
    isOpen: true,
    height: 0,
    width: 0,
  }),
  created() {
    if (this.$bus) {
      this.$bus.$on("sidebarOpen", (isOpen) => (this.isOpen = isOpen));
    }
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth < 1140) {
        this.$bus.$emit("sidebarOpen", false);
        this.isOpen = false;
      } else {
        this.$bus.$emit("sidebarOpen", true);
        this.isOpen = true;
      }
    },
    onNavigate(item) {
      // Re-emit
      this.$emit("navigate", item.href);
      if (window.innerWidth < 992) {
        this.$bus.$emit("sidebarOpen", false);
        this.isOpen = false;
      }
    },
  },
};
</script>
